import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DownloadCircleGlyph = /*#__PURE__*/createElement("g", {
  id: "download_circle",
  fill: "none",
  style: {
    transform: 'translate(6px, 6px) scale(4)'
  }
}, /*#__PURE__*/createElement("path", {
  d: "M8.75 16.5C13.063 16.5 16.5 13.063 16.5 8.75C16.5 4.43696 13.063 1 8.75 1C4.43696 1 1 4.43696 1 8.75C1 13.063 4.43696 16.5 8.75 16.5Z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M6.16699 9.81913L8.75033 12.4565M8.75033 12.4565L11.3337 9.81913M8.75033 12.4565L8.75033 5.0435",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const DownloadCircle = createSvg({
  name: 'download_circle',
  path: DownloadCircleGlyph
});

export default DownloadCircle;
export { DownloadCircleGlyph };
